module.exports = __webpack_public_path__ + "4d4e1487733af4409d49b274bf31b3b9.MP3";